import { render, staticRenderFns } from "./show.chats.page.vue?vue&type=template&id=5a5940ff&"
import script from "./show.chats.page.vue?vue&type=script&lang=js&"
export * from "./show.chats.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports